import { Incidente } from '@/domain/entities/incidente';
import { IncidentesParamsDTO } from '@/application/dto/incidentes/IncidenteParamsDTO';
import { IIncidenteRepository } from '@/domain/repositories/IIncidenteRepository';

export class GetIncidentesUseCase {
  constructor(
    private readonly repository: IIncidenteRepository
  ) {}

  async execute(params?: IncidentesParamsDTO): Promise<Incidente[]> {
    console.log("USECASE", params);
    return this.repository.getincidentes(params);
  }
}